import * as action from "../../utils/Actions";
import { request } from "../../services/Request";
import * as url from "../../utils/Url";


export function updatePageTitle(title){
  return (dispatch)=>
  dispatch({
    type: action.UPDATE_PAGE_TITLE,
    meta: {title: title}
  });
}

export function showErrorToast(message){
  return (dispatch)=>
    dispatch({
      type: action.SHOW_ERROR_TOAST,
      meta: {message: message}
    });
}

export function resetErrorToast(){
    return (dispatch)=>
    dispatch({
      type: action.RESET_TOAST
    });
}

export function setErrorLog(title,description,origin){
  return (dispatch)=>
  dispatch({
    type: action.SET_ERROR_LOG,
    payload: request(url.USER_SERVICE).post(`/user/app-crashes?title=${title}&description=${description}&origin=${origin}`)
  }).catch(response => {});
}